import { Check, Copy } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/Domain/components/Shared/Button/Button';
import { useCopiedFeedback } from '@/Domain/hooks/App/useCopiedFeedback.hook';

interface ScriptDisplayProps {
  script: string;
  onCopy?: () => void;
}

export const WidgetScript = ({ script, onCopy }: ScriptDisplayProps) => {
  const { t } = useTranslation('common');
  const { copied, markCopied } = useCopiedFeedback();

  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text).then(
      () => {
        markCopied();
        onCopy?.();
      },
      (err) => {
        console.error('Could not copy text: ', err);
      },
    );
  };

  return (
    <div className="mt-2 overflow-hidden rounded-2xl border border-border bg-muted text-muted-foreground">
      <pre className="custom-scroll mb-0 overflow-x-auto whitespace-pre p-3 font-mono text-xs leading-relaxed">
        <code>{script}</code>
      </pre>
      <div className="flex justify-end border-t border-border p-2">
        <Button
          size="xs"
          variant="dark"
          onClick={() => !copied && copyToClipboard(script)}
          className={copied ? 'pointer-events-none' : ''}
        >
          {copied ? (
            <>
              <Check />
              {t('copied')}
            </>
          ) : (
            <>
              <Copy />
              {t('copy')}
            </>
          )}
        </Button>
      </div>
    </div>
  );
};
